// Global "table zoom" store.
// Tujuan: shortcut zoom browser (Ctrl +/-/0) hanya memengaruhi UKURAN FONT tabel,
// BUKAN lebar/geometri tabel & bukan seluruh layout.
// Batas kiri & kanan tabel TETAP PENUH (terkunci ke lebar kartu/kontainer) — hanya
// font yang membesar/mengecil. Kita preventDefault zoom asli browser lalu menaikkan/
// menurunkan skala font pada elemen <table>.

const KEY = "app_table_zoom";
// Rentang lebih lebar agar bisa memperbesar font (zoom in) maupun memperkecil (zoom out).
const MIN = 0.6;
const MAX = 1.6;
const clamp = (z) => Math.min(MAX, Math.max(MIN, Math.round(z * 100) / 100));

export const ZOOM_MIN = MIN;
export const ZOOM_MAX = MAX;

let zoom = (() => {
  try {
    const v = parseFloat(localStorage.getItem(KEY));
    return v >= MIN && v <= MAX ? v : 1;
  } catch {
    return 1;
  }
})();

const subs = new Set();

export const getTableZoom = () => zoom;

export const setTableZoom = (z) => {
  const c = clamp(z);
  if (c === zoom) return;
  zoom = c;
  try { localStorage.setItem(KEY, String(zoom)); } catch { /* ignore */ }
  subs.forEach((f) => f(zoom));
};

export const subscribeTableZoom = (fn) => {
  subs.add(fn);
  return () => subs.delete(fn);
};

// Cegat tombol keyboard zoom browser hanya saat ada tabel di layar (ref-counted).
let count = 0;
let handler = null;

export const attachZoomKeys = () => {
  count += 1;
  if (count === 1 && typeof window !== "undefined") {
    handler = (e) => {
      if (!(e.ctrlKey || e.metaKey)) return;
      if (e.key === "=" || e.key === "+") { e.preventDefault(); setTableZoom(zoom + 0.1); }
      else if (e.key === "-" || e.key === "_") { e.preventDefault(); setTableZoom(zoom - 0.1); }
      else if (e.key === "0") { e.preventDefault(); setTableZoom(1); }
    };
    window.addEventListener("keydown", handler, { passive: false });
  }
};

export const detachZoomKeys = () => {
  count = Math.max(0, count - 1);
  if (count === 0 && handler && typeof window !== "undefined") {
    window.removeEventListener("keydown", handler);
    handler = null;
  }
};
